document.addEventListener('change', event => {
    if( [...document.querySelectorAll('input.form-control')].includes(event.target) ) {
        event.target.value.length > 0
            ? [... event.target.labels].map(label => label.classList.contains('label-as-placeholder') && label.classList.add('d-none'))
            : [... event.target.labels].map(label => label.classList.contains('label-as-placeholder') && label.classList.remove('d-none'))
    }
})